import { createReportIdeasHubBtnClicked } from '../../../../shared/mixpanel/events';
import store from '../store';
import { reportPageView } from './reportPageView';

const reportIdeasHubBtnClicked = createReportIdeasHubBtnClicked(store);

export { reportPageView, reportIdeasHubBtnClicked };
